import { useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import LoadingDots from '../LoadingDots';
import logo from '../../../images/mg_logo.png';

import './GlobalLoader.scss';

const RETRY_KEY = 'mg_conn_error_retried';

const GlobalLoader = ({ show, error }) => {
  const { t } = useTranslation();
  const hasRetried = error && !!sessionStorage.getItem(RETRY_KEY);

  // Keep the loader mounted through its fade-out so the opacity transition can
  // play before it leaves the DOM.
  const [render, setRender] = useState(show);

  useLayoutEffect(() => {
    if (show) setRender(true);
  }, [show]);

  // Lock background scroll while the loader is on screen. Apply to both <html>
  // and <body> since either can be the scroll container.
  useLayoutEffect(() => {
    if (!render) return undefined;

    document.documentElement.classList.add('GlobalLoaderOpen');
    document.body.classList.add('GlobalLoaderOpen');

    return () => {
      document.documentElement.classList.remove('GlobalLoaderOpen');
      document.body.classList.remove('GlobalLoaderOpen');
    };
  }, [render]);

  if (!render) return null;

  // Once the fade-out finishes, unmount.
  const handleTransitionEnd = (e) => {
    if (e.target === e.currentTarget && !show) setRender(false);
  };

  return (
    <div
      className={cx('GlobalLoader', { hidden: !show })}
      role="status"
      aria-live="polite"
      aria-label={t('loader.loading')}
      onTransitionEnd={handleTransitionEnd}
    >
      <div className="content">
        <img className="logo" src={logo} alt="MiGrupo" />
        {error ? (
          <div className="error">
            <p>{hasRetried ? t('loader.stillFailing') : t('loader.failed')}</p>
            <button
              type="button"
              className="mg-btn mg-btn--primary"
              onClick={() => {
                sessionStorage.setItem(RETRY_KEY, 'true');
                window.location.reload();
              }}
            >
              {t('loader.reload')}
            </button>
            {!hasRetried && <p className="hint">{t('loader.tryLater')}</p>}
          </div>
        ) : (
          <LoadingDots className="dots" width="3em" />
        )}
      </div>
    </div>
  );
};

export default GlobalLoader;
